/** Nome do produto exibido na interface. */
export const APP_NAME = "Potência Lucrativa";

/** Descrição curta para meta / rodapé. */
export const APP_TAGLINE =
  "Gestão financeira e lucratividade para o seu negócio";
